{
  "version": 1,
  "asset_id": "fba05c62-af0c-4465-92c0-c6538b7de586",
  "project_id": "7948fbe6-b4e3-485f-995c-f8f53bd7ab6b",
  "url": "/__l5e/assets-v1/fba05c62-af0c-4465-92c0-c6538b7de586/palm-villa-entry-courtyard.png",
  "r2_key": "a/v1/7948fbe6-b4e3-485f-995c-f8f53bd7ab6b/fba05c62-af0c-4465-92c0-c6538b7de586/palm-villa-entry-courtyard.png",
  "original_filename": "palm-villa-entry-courtyard.png",
  "size": 3071796,
  "content_type": "image/png",
  "created_at": "2026-07-05T03:36:15Z"
}
